export default __webpack_public_path__ + "static/media/inspection.dc6bba26.svg";